import Cookies from 'js-cookie';
import md5 from 'js-md5';
import JSEncrypt from 'jsencrypt';

function encryptInfo(publicKey, info) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  const res = encryptor.encrypt(info);
  return res;
}

/**
 * 判断是否处于PC
 *
 * @name: isPC
 * @param {String} u
 */
function isPC(u) {
  const Agents = [
    'Android',
    'iPhone',
    'webOS',
    'BlackBerry',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod'
  ];
  let flag = true;
  for (let i = 0; i < Agents.length; i++) {
    if (u.indexOf(Agents[i]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

/**
 * 设置rem函数
 *
 * @name: setRem
 */
function setRem() {
  const screenWidth = 1280
  const scale = screenWidth / 100
  const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
  // 设置页面根节点字体大小
  document.documentElement.style.fontSize =
    htmlWidth / scale + 'px';
}

const cookie = function() {
  // Helpers
  var doc = window.document;
  var MILLISECONDS_OF_DAY = 24 * 60 * 60 * 1e3;

  function encode(str) {
    return encodeURIComponent(str);
  }

  function decode(str) {
    return decodeURIComponent(str.replace(/\+/g, ' '));
  }

  function isNotEmptyStr(str) {
    return typeof str === 'string' && str !== '';
  }

  var cookie_obj = {
    /**
     * 获取cookie值
     *
     * @param name
     * @param options
     * @returns {*}
     */
    get: function(name, options) {
      options = options || {};
      var ret, matchArr;
      if (isNotEmptyStr(name)) {
        if (
          (matchArr = String(doc.cookie).match(
            new RegExp('(?:^| )' + name + '(?:(?:=([^;]*))|;|$)')
          ))
        ) {
          if (matchArr[1]) {
            ret = !options.decode ? matchArr[1] : decode(matchArr[1]);
          }
        }
      }
      return ret;
    },
    /**
     * 设置cookie
     *
     * @param name
     * @param val
     * @param options
     * @returns {*|string}
     */
    set: function(name, val, options) {
      options = options || {};
      let text = String(options.encode ? encode(val) : val);
      let date = options.expires; // 过期时间, 单位:天
      const domain = options.domain || document.domain; // 有效域名
      const path = options.path || '/'; // 有效路径
      const secure = options.secure;
      // 是否安全设置
      // 从当前时间开始，多少天后过期
      if (typeof date === 'number') {
        date = new Date();
        date.setTime(date.getTime() + options.expires * MILLISECONDS_OF_DAY);
      }
      // expiration date
      if (date instanceof Date) {
        text += '; expires=' + date.toUTCString();
      }
      // domain
      if (isNotEmptyStr(domain)) {
        text += '; domain=' + domain;
      }
      // path
      if (isNotEmptyStr(path)) {
        text += '; path=' + path;
      }
      // secure
      if (secure) {
        text += '; secure';
      }
      doc.cookie = name + '=' + text;
      return text;
    },
    /**
     * 删除cookie
     * @param name
     * @param options
     * @returns {*|string}
     */
    del: function(name, options) {
      return this.set(name, '', {
        expires: -1,
        domain: options.domain || document.domain,
        path: options.path || '/',
        secure: options.secure
      });
    }
  };
  return cookie_obj;
};
const getCookieKey = (key) => Cookies.get(key);
const removeCookieKey = (key) => Cookies.remove(key);
const stringToMd5 = (key) => md5(key);

const collectAppGroupToken = () => {
  if (!window.RENDER_DATA.APP_GROUP_OPTIONS) {
    return [];
  }
  const list = [];
  (window.RENDER_DATA.APP_GROUP_OPTIONS || []).map((item) => {
    const match = getCookieKey(item + '_TOKEN');
    if (match) {
      list.push({
        key: item,
        val: match
      });
    }
    return item;
  });
  return list;
}
export {
  isPC, setRem, encryptInfo, cookie,
  getCookieKey,
  removeCookieKey,
  stringToMd5,
  collectAppGroupToken
};
